export default "__VITE_ASSET__LVhujIej__"